import { Notify } from 'react-redux-notify'
import {
  compose,
  lifecycle,
  withStateHandlers,
  defaultProps
} from 'recompose'

import { initGA, logPageView } from '../../utils/analytics'
import { getNotifyOpts } from '../../lib/notification'
import { withI18next } from '../../lib/withI18next'
import Header from '../Header'
import Sidebar from '../Sidebar'
import Footer from '../Footer'
import LanguageSelectingModal from '../LanguageSelectingModal'
import '../../styles/_main.scss'

const withMainLayout = PassedComponent => props => {
  const { user, title, t, isAuthenticated, contentImage, cart } = props
  return (
    <div>
      <div className="container ma-container">
        <Header
          user={user}
          isAuthenticated={isAuthenticated}
          cart={cart}
        />
        <div className="columns reverse-row-order">
          <div className="column is-3">
            <Sidebar />
          </div>
          <div className="column is-9 content-right">
            <section className="section">
              <div className=" ma-content">
                <h3 className="is-size-3 m-b-lg">{t(title)}</h3>
                { contentImage ? (
                  <p className="m-b-md">
                    <img src={props.contentImage} />
                  </p>
                ) : null }
                <PassedComponent {...props} />
              </div>
            </section>
          </div>
        </div>
        <Footer
          currentLanguage={props.language}
          t={t}
        />
        <LanguageSelectingModal t={t} />
      </div>
      {
        props.isClient &&
        <Notify
          {...getNotifyOpts()}
        />
      }
    </div>
  )
}

export default PassedComponent => compose(
  withI18next(['common']),
  defaultProps({
    contentImage: '/static/images/esi.jpg',
    title: ''
  }),
  withStateHandlers(
    {
      isClient: false
    },
    {
      setClient: () => val => ({ isClient: !!val })
    }
  ),
  lifecycle({
    componentDidMount () {
      this.props.setClient(true)
      if (!window.GA_INITIALIZED) {
        initGA()
        window.GA_INITIALIZED = true
      }
      logPageView()
    }
  })
)(withMainLayout(PassedComponent))



// WEBPACK FOOTER //
// ./components/Layouts/index.js